<template>
  <v-container fluid>
    <div class="wineLabelItemComponentForm">
      <v-form ref="form" v-model="valid" lazy-validation>
        <!--<v-layout row wrap>-->
        <!--<v-flex xs8>-->
        <!--<v-text-field-->
        <!--v-model="ID"-->
        <!--label="ID" readonly-->
        <!--&gt;</v-text-field>-->
        <!--</v-flex>-->
        <!--</v-layout> &lt;!&ndash; /.ID &ndash;&gt;-->

        <div class="VineYear__Content">
            <v-layout row wrap>
              <v-flex xs3 pa-2>
                <v-text-field
                  v-model="pozicija"
                  label="Redosled na prikazu"
                  type="number"
                  persistent-hint
                  return-object
                  v-on:keypress="isNumber"
                ></v-text-field>
              </v-flex>
              <v-flex xs3 pa-2>
                <v-text-field v-model="barkod" label="Bar kod"></v-text-field>
              </v-flex>
              <v-flex xs3 pa-2>
                <v-text-field
                  v-if="!samo_proizvodnja"
                  v-model="zapremina_boce"
                  label="Zapremina boce (l)"
                  type="number"
                  :rules="[(v) => !!v || 'Obavezan podatak']"
                  required
                  persistent-hint
                  return-object
                ></v-text-field>
              </v-flex>
              <v-flex xs3 pa-2>
                <v-text-field
                  v-model="service_temperature"
                  label="Temperatura služenja (°C)"
                  type="number"
                  persistent-hint
                  return-object
                ></v-text-field>
              </v-flex>
            </v-layout>
        <div class="TankDetails">
          <v-layout row wrap>
            <v-flex xs6>
              <v-textarea
                :key="autoGrowHack"
                v-model="opis"
                label="Opis"
                auto-grow
                rows="9"
              ></v-textarea>
            </v-flex>
            <v-flex xs6 style="padding-left:10px;">
              <v-textarea
                :key="autoGrowHack"
                v-model="food_pairing"
                label="Hrana"
                auto-grow
                rows="9"
              ></v-textarea>
            </v-flex>
          </v-layout>
        </div>
        </div>
        <!-- /.Tank -->

        <v-layout row wrap>
          <v-flex xs12>
            <v-btn :disabled="!valid" @click="submit" class="AppButtonFilled"
              >Sačuvaj</v-btn
            >
            <v-btn @click="clear" class="AppButtonOutlined">odustani</v-btn>
          </v-flex>
        </v-layout>
        <!-- <v-layout row wrap>
          <v-flex xs12 class="text-xs-center text-sm-center text-md-center text-lg-center">
          <img :src="imageUrl" height="150" v-if="imageUrl"/>
          <v-text-field label="Select Image" @click='pickFile' v-model='imageName' prepend-icon='attach_file'></v-text-field>
          <input
            type="file"
            style="display: none"
            ref="image"
            accept="image/*"
            @change="onFilePicked"
          >
        </v-flex>
        </v-layout>
        <v-layout row wrap>
          <v-flex xs12>
            <v-btn @click="uploadPicture" class="AppButtonFilled"
              >Uploaduj sliku</v-btn
            >
          </v-flex>
        </v-layout> -->
        <!-- /.Action buttons -->
      </v-form>
      <TokenComponent ref="frmtoken" />
    </div>
  </v-container>
</template>

<script>
import { serverBus } from "../main";
import { readJSON } from "../helpers/Functions";
import TokenComponent from "../components/Token";

export default {
  props: ["item"],
  name: "WineLabelItem",
  components: {
    TokenComponent,
  },
  data: () => ({
    autoGrowHack: false,
    valid: true,
    ID: "0",
    naziv: "",
    wt_items: [],
    select: "",
    opis: "",
    barkod: "",
    zapremina_boce: undefined,
    service_temperature: undefined,
    food_pairing: undefined,
    pozicija: undefined,
    samo_proizvodnja: false,
    tipVina: undefined,
    
    title: "Image Upload",
    // dialog: false,
    imageName: '',
    imageUrl: '',
    imageFile: ''
  }),
  watch: {
    item: function (val) {
      if (val !== undefined) {
        console.log(val);

        this.ID = val.id;
        this.naziv = val.name;
        this.opis = val.description;
        this.barkod = val.ean;

        this.samo_proizvodnja = val.inProduction;

        this.zapremina_boce = val.bottleVolumeInLiters;
        this.service_temperature = val.serviceTemperature;
        this.food_pairing = val.foodPairing;
        this.pozicija = val.position;
        this.tipVina = val.wineType;

        // if (val.wineType !== null) {
        //   this.select = val.wineType;
        // } else {
        //   this.select = "";
        // }
      }
    },
  },
  methods: {
    pickFile() {
      this.$refs.image.click()
    },
    isNumber(e) {
      e = e || window.event;
      var charCode = (typeof e.which == "undefined") ? e.keyCode : e.which;
      var charStr = String.fromCharCode(charCode);

      

      if (!charStr.match(/^[0-9]+$/))
      e.preventDefault();
      return true;
    },
    onFilePicked(e) {
      const files = e.target.files
      if (files[0] !== undefined) {
        this.imageName = files[0].name
        if (this.imageName.lastIndexOf('.') <= 0) {
          return
        }
        const fr = new FileReader()
        fr.readAsDataURL(files[0])
        fr.addEventListener('load', () => {
          this.imageUrl = fr.result
          this.imageFile = files[0] // this is an image file that can be sent to server...

          console.log(this.imageUrl);
          console.log(this.imageFile);
        })
      } else {
        this.imageName = ''
        this.imageFile = ''
        this.imageUrl = ''
      }
    },
    changeInProduction(e) {
      if (e) this.zapremina_boce = undefined;
    },
    changeSifarnik() {
      var complexObjectWineType = {
        id: this.tipVina.id,
      };

      var complexObject = {
        id: this.ID,
        name: this.naziv,
        wineType: complexObjectWineType,
        ean: this.barkod,
        description: this.opis,
        bottleVolumeInLiters: this.zapremina_boce,
        serviceTemperature: this.service_temperature,
        foodPairing: this.food_pairing,
        position: this.pozicija,
      };

      if (this.samo_proizvodnja)
        var complexObject = {
          id: this.ID,
          name: this.naziv,
          wineType: complexObjectWineType,
          ean: this.barkod,
          description: this.opis,
          inProduction: 1,
          serviceTemperature: this.service_temperature,
          foodPairing: this.food_pairing,
          position: this.pozicija,
        };
      else
        var complexObject = {
          id: this.ID,
          name: this.naziv,
          wineType: complexObjectWineType,
          ean: this.barkod,
          description: this.opis,
          bottleVolumeInLiters: this.zapremina_boce,
          serviceTemperature: this.service_temperature,
          foodPairing: this.food_pairing,
          position: this.pozicija,
          inProduction: 0,
        };

      this.$http
        .put(
          this.globalServiceLocation +
            this.globalPort +
            "/wine_label/update/" +
            this.ID,
          complexObject,
          {
            headers: {
              "Content-Type": "application/json",
              Authorization: "Bearer  " + localStorage.getItem("user-token"),
            },
          }
        )
        .then((response) => {
          this.$emit("newdata", null);
        })
        .catch((e) => {
          // // console.log(e.response);

          if (!e.response) {
            alert(
              this.$t("error.message")
            );
          } else {
            if (e.response.status === 401) {
              this.$refs.frmtoken
                .osvezavanjeTokena(localStorage.getItem("user-refresh-token"))
                .then((result) => {
                  // // console.log(result);
                  // // console.log("Novi token - " + localStorage.getItem("user-token"));

                  this.$http
                    .put(
                      this.globalServiceLocation +
                        this.globalPort +
                        "/wine_label/update/" +
                        this.ID,
                      complexObject,
                      {
                        headers: {
                          "Content-Type": "application/json",
                          Authorization:
                            "Bearer  " + localStorage.getItem("user-token"),
                        },
                      }
                    )
                    .then((response) => {
                      this.$emit("newdata", null);
                    })
                    .catch((e) => {
                      // // console.log(e.response);

                      let pomError = readJSON(e.response.data.message);
                      alert(pomError);
                    });
                });
            } else {
              let pomError = readJSON(e.response.data.message);
              alert(pomError);
            }
          }
        });
    },
    uploadPicture() {
      

      // var FormData = require('form-data');
      // var fs = require('fs');
      var data = new FormData();
      data.append('file', this.imageFile);


      // let complexObject = this.imageUrl;

      


      this.$http
        .post(
          this.globalServiceLocation +
            this.globalPort +
            "/wine/upload",
            data,
          {
            headers: {
              
              Authorization: "Bearer  " + localStorage.getItem("user-token"),
            },
          }
        )
        .then((response) => {
          // this.$emit("newdata", null);
          alert(1234)
        })
        .catch((e) => {
          // // console.log(e.response);

          if (!e.response) {
            alert(
              this.$t("error.message")
            );
          } else {
            if (e.response.status === 401) {
              this.$refs.frmtoken
                .osvezavanjeTokena(localStorage.getItem("user-refresh-token"))
                .then((result) => {
                  // // console.log(result);
                  // // console.log("Novi token - " + localStorage.getItem("user-token"));

                  this.$http
                    .post(
                      this.globalServiceLocation +
                        this.globalPort +
                        "/wine/upload",
                      complexObject,
                      {
                        headers: {
                          "Content-Type": "application/json",
                          Authorization:
                            "Bearer  " + localStorage.getItem("user-token"),
                        },
                      }
                    )
                    .then((response) => {
                      // this.$emit("newdata", null);
                      alert(1234)
                    })
                    .catch((e) => {
                      // // console.log(e.response);

                      let pomError = readJSON(e.response.data.message);
                      alert(pomError);
                    });
                });
            } else {
              let pomError = readJSON(e.response.data.message);
              alert(pomError);
            }
          }
        });
    },
    getAllTipoveVina() {
      this.$http
        .get(this.globalServiceLocation + this.globalPort + "/wine_type/all", {
          headers: {
            "Content-Type": "application/json",
            Authorization: "Bearer  " + localStorage.getItem("user-token"),
          },
        })
        .then((response) => {
          //// // console.log(response.data);

          this.wt_items = response.data;
        })
        .catch((e) => {
          // // console.log(e.response);

          if (!e.response) {
            alert(
              this.$t("error.message")
            );
          } else {
            if (e.response.status === 401) {
              this.$refs.frmtoken
                .osvezavanjeTokena(localStorage.getItem("user-refresh-token"))
                .then((result) => {
                  // // console.log(result);
                  // // console.log("Novi token - " + localStorage.getItem("user-token"));

                  this.$http
                    .get(
                      this.globalServiceLocation +
                        this.globalPort +
                        "/wine_type/all",
                      {
                        headers: {
                          "Content-Type": "application/json",
                          Authorization:
                            "Bearer  " + localStorage.getItem("user-token"),
                        },
                      }
                    )
                    .then((response) => {
                      //// // console.log(response.data);

                      this.wt_items = response.data;
                    })
                    .catch((e) => {
                      // // console.log(e.response);

                      let pomError = readJSON(e.response.data.message);
                      alert(pomError);
                    });
                });
            } else {
              let pomError = readJSON(e.response.data.message);
              alert(pomError);
            }
          }
        });
    },
    submit() {
      if (this.$refs.form.validate()) this.changeSifarnik();
    },
    clear() {
      this.$refs.form.reset();
      this.ID = 0;

      this.$emit("close", null);
    },
  },
  mounted() {
    this.clear();

    this.getAllTipoveVina();

    serverBus.$on("applied_wine_label", (item) => {
      //alert(item.name);
      this.ID = item.id;
      this.naziv = item.name;
      this.opis = item.description;
      this.barkod = item.ean;

      this.samo_proizvodnja = item.inProduction;

      this.zapremina_boce = item.bottleVolumeInLiters;
      this.service_temperature = item.serviceTemperature;
      this.food_pairing = item.foodPairing;
      this.pozicija = item.position;
      this.tipVina = item.wineType;

      // if (item.wineType !== null) {
      //   this.select = item.wineType;
      // } else {
      //   this.select = "";
      // }
    });
  },
};
</script>
    
<style lang="scss" scoped>
@import "./../assets/sass/parts/modalStyles";
@import "../assets/sass/parts/_tanksRoom.scss";

.VineYear {
  margin-top: 0px;
  margin-bottom: 80px;
  &__Header {
    display: flex;
    padding: 4px 15px 0;
    justify-content: space-between;
    h2 {
      font-family: NunitoSans, sans-serif;
      font-size: 32px;
      letter-spacing: 0;
      font-weight: 300;
      // text-transform: uppercase;
      color: #000;
    }
    .more_info {
      color: #fff;
      border: solid 1px;
      margin-top: 6px;
    }
    &--crveno {
      background-color: #8e302f;
      h2 {
        color: #ffffff;
      }
      .more_info {
        color: #ffffff;
        border-color: #fff;
      }
    }
    &--belo {
      background-color: #fcf5e2;

      h2 {
        color: #d30031;
      }
      .more_info {
        border-color: #d30031;
      }
    }
    &--penusavo {
      background-color: #d8d5cb;

      h2 {
        color: #d30031;
      }
      .more_info {
        border-color: #d30031;
      }
    }
    &--rose {
      background-color: #ffcbc4;

      h2 {
        color: #d30031;
      }
      .more_info {
        border-color: #d30031;
      }
    }
    &--pojacano {
      background-color: #892b23;

      h2 {
        color: #ffffff;
      }
      .more_info {
        color: #ffffff;
        border-color: #fff;
      }
    }
    &--slatko {
      background-color: #fcc862;

      h2 {
        color: #d30031;
      }
      .more_info {
        border-color: #d30031;
      }
    }
  }

  &__Content {
    display: flex;
    flex-wrap: wrap;
    &__Vine {
      display: flex;
      // margin-right: 30px;
      .VineBox {
        margin-right: 15px;
      }
      .VineYears {
        max-width: 120px;
        height: 100%;
        max-height: 310px;
        margin: -3px -3px -3px -3px;
        display: inline-flex;
        flex-wrap: wrap;
        flex-direction: column;
        justify-content: flex-start;
        span {
          display: block;
          width: 63px;
          height: 33px;
          padding-top: 2px;
          margin: 3px;
          // border-radius: 6px;
          // border: solid 1px #9b9b9b;
          font-family: NunitoSans, sans-serif;
          font-size: 18px;
          font-weight: bold;
          letter-spacing: 0;
          text-align: center;
          color: #000000;
        }
      }
    }
  }
}
.Description textarea {
  height: 40px;
}

div.v-input.Description.v-textarea.v-text-field {
  margin-top: 0px;
}

div.flex.pa-2 {
  padding-bottom: 0px !important;
  padding-top: 0px !important;
}

.TankDetails {
  display: flex;
  padding: 0 10px;
  flex-direction: column;
  // border-left: 1px solid #979797;
  width: 100%;
  @include bp(_1200) {
    padding: 0 10px;
  }
  &__Item {
    > * {
      width: 30%;
      display: inline-block;
      vertical-align: middle;
    }
    margin-bottom: 4px;
    font-family: "NunitoSans", sans-serif;
    font-size: 16px;
    .label {
      width: 130px;
      letter-spacing: 0;
      color: #9b9b9b;
      margin-right: 10px;
      text-align: right;
      @include bp(_1200) {
        width: auto;
      }
    }
    .value {
      width: 50%;
      color: #000;
    }
    .maka {
      max-width: 200px;
      letter-spacing: 0;
      color: #9b9b9b;
      margin-right: 20px;
      @include bp(_1200) {
        width: auto;
      }
    }
    .kvaka {
      max-width: 45px;
      letter-spacing: 0;
      color: #9b9b9b;
      margin-right: 20px;
      @include bp(_1200) {
        width: auto;
      }
    }
  }
}
</style>
